import * as React from 'react';
import {Link as RouterLink, withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {getSingularEntityType} from 'nutshell-core/utils/get-singular-entity-type';

import {Link} from 'shells/link/link';

import type {EntityFormType} from './types';

type OwnProps = {
    type: EntityFormType;
};

type Props = OwnProps & ContextRouter;

/*
 * Component displayed only on the EntityLists when they are empty - pushes
 * people to create a person/company/lead by opening the Create Modal
 */
export class CreateFormOpenButtonComponent extends React.PureComponent<Props> {
    render() {
        return (
            <Link
                variant='button-primary'
                size='big'
                // @ts-expect-error
                as={RouterLink}
                to={{
                    hash: `/create/${this.props.type}`,
                    search: this.props.location.search,
                    state: {modal: true},
                }}
            >
                <span>{`Add a new ${getSingularEntityType(this.props.type)}`}</span>
            </Link>
        );
    }
}

// @ts-expect-error
export const CreateFormOpenButton = withRouter<OwnProps>(CreateFormOpenButtonComponent);
